module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0086.jpg?v=4650e5a3";